<template>
  <div class="s-project">
    <ProjectLogin class="s-header" @setMenu="switchMenu" @onExtMenu="onExtMenu" @setCollapse="setCollapse($event)">
    </ProjectLogin>
    <transition name="fade">
      <NavMenu v-if="isShowMenu" class="navMenu" @setMenu="switchMenu($event)"></NavMenu>
    </transition>
    <transition name="fade">
      <section ref="projectHome">
        <Center v-if="sceneType==1" class="centerBox" :url="centerImg" :centerImgId="centerImgId" :data="centerData"
          :isShowMenu="isShowMenu"></Center>
        <Webgl v-if="sceneType==2" class="centerBox" :projectid="projectId" @glPanel="glPanel($event)"
          @levelchange="levelchange" :panelShow="panelShow"></Webgl>
        <ListBlock v-if="panelIds.length>0" class="list-block-left"
          :class="{ 'left-show': panelShow === true, 'left-hide': panelShow === false }" :ids="left"
          :panelIds="panelIds"></ListBlock>
        <ListBlock v-if="isRightBlock && panelIds.length>0" class="list-block-right"
          :class="{ 'right-show': panelShow === true, 'right-hide': panelShow === false }" :ids="right"
          :panelIds="panelIds"></ListBlock>
      </section>
    </transition>
    <BaseinfoTable v-if="sceneType==1"></BaseinfoTable>
    <TextBlock v-if="panelIds.length>0 && currentLevel==0 && sceneType==2" class="s-hide-panel">
      <span @click="switchPanel">{{ panelTitle }}</span>
    </TextBlock>
    <TextBlock v-if="panelIds.length>0 && currentLevel==2" class="b-hide-panel">
      <span @click="productInshide">返回</span>
    </TextBlock>
    <div class="loading-x" v-if="loading && sceneType==2">
      <img src="/static/images/svolt/loading.gif" />
      <span>3D模型加载中，请稍后</span>
    </div>
  </div>
</template>

<script>
  import ProjectLogin from '@/views/svolt/project/components/nanwang/header';
  import Webgl from '@/components/webgl/index';
  import Center from '@/views/svolt/project/components/nanwang/center';
  import BaseinfoTable from '@/views/svolt/project/components/nanwang/baseinfo-table';
  import PROJECTAPI from '@/api/svolt/project';
  import USERAPI from '@/api/user';
  import {
    getInfo
  } from '@/utils/auth';
  import NavMenu from '@/views/svolt/project/components/nanwang/navMenu';
  import ListBlock from '@/views/svolt/project/components/nanwang/list-block';
  import TextBlock from '../components/text-block';
  import {
    centerImages
  } from '@/utils/centerImages';
  export default {
    name: 'PorjectIndex',
    components: {
      ProjectLogin,
      Webgl,
      NavMenu,
      ListBlock,
      TextBlock,
      Center,
      BaseinfoTable
    },
    data() {
      return {
        interval: null,
        loading: true,
        drawer: false,
        activeProject: 'projectHome',
        projectId: '',
        left: [1, 2, 3],
        right: [4, 5, 6],
        isShowMenu: false,
        panelTitle: '隐藏面板',
        panelShow: false,
        isRightBlock: false,
        centerData: {
          electricsupplypower: {
            desc: '电网',
            status: '',
            unit: '',
            value: '0.0'
          },
          storedenergypower: {
            desc: '储能',
            status: '#FFC107',
            unit: '',
            value: '0.0'
          },
          charginggunpowerA1: {
            desc: '1#枪',
            status: '#FFC107',
            unit: 'kW',
            value: '0.0'
          },
          solarpower: {
            desc: '光伏',
            status: '#FFC107',
            unit: '',
            value: '0.0'
          },
          charginggunpowerB2: {
            desc: '2#枪',
            status: '#FFC107',
            unit: 'kW',
            value: '0.0'
          },
          charginggunpowerA2: {
            desc: '2#枪',
            status: '#FFC107',
            unit: 'kW',
            value: '0.0'
          },
          charginggunpowerC1: {
            desc: '1#枪',
            status: '#FFC107',
            unit: 'kW',
            value: '0.0'
          },
          charginggunpowerB1: {
            desc: '1#枪',
            status: '#FFC107',
            unit: 'kW',
            value: '0.0'
          },
          charginggunpowerC2: {
            desc: '2#枪',
            status: '#FFC107',
            unit: 'kW',
            value: '0.0'
          },
          loadpower: {
            desc: '负荷',
            status: '#FFC107',
            unit: 'kW',
            value: '0.0'
          },
          flywheelenergystoragepower: {
            desc: '飞轮储能',
            status: '#FFC107',
            unit: 'kW',
            value: '0.0'
          },
        },
        centerImg: '../../../../static/images/boss/panelPic/ep05.png',
        statisticsData: [],
        panelIds: [],
        sceneType: 1,
        centerImgId: 120005,
        currentLevel: 0 //级别等于2不显示面板按钮
      };
    },
    methods: {
      //个场景实时功率
      searchRealTimePower() {
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.searchRealTimePower(params).then(res => {
          if (res.data.code == 200) {
            if (JSON.stringify(res.data.data) != "{}") {
              this.centerData = res.data.data;
            }
          }
        });
      },
      //获取资源权限列表
      getAuth() {
        let tempAuth = localStorage.getItem('ActiveProjectModule');
        if (tempAuth) {
          let json = JSON.parse(tempAuth);
          this.authority = [];
          let ids = [];
          json.item.forEach(item => {
            if (item.showOrder > 0 && item.showOrder < 9) {
              this.authority.push({
                showOrder: item.showOrder,
                resourceId: item.resourceId,
                resourceNameShow: item.resourceNameShow
              });
              ids.push(item.resourceId);
            }
          });
          this.authority = ids;
        }
      },
      levelchange(e) {
        this.currentLevel = e
      },
      productInshide() {
        // console.log(levelsShowIns)
        levelsShowIns.resetAll()
        levelsShowIns.eventbus.$emit("levelchange", 0);
      },
      onExtMenu() {
        this.drawer = true;
      },
      init() {
        this.activeProject = this.$route.query.appid || 'projectHome';
        this.getAuth();
        let info = JSON.parse(getInfo());
        let panelIds = [];
        for (let i in this.panelIds) {
          panelIds.push(this.panelIds[i].panelId);
        }
        if (panelIds.includes(90016)) {
          this.searchSolarAndEnergyStorageIncomeAndSaveEmissions();
        }
        if (panelIds.includes(90017)) {
          this.projectEnergySaveStatistics();
        }
        if (this.sceneType == 1) {
          //各场景实时功率
          this.searchRealTimePower();
        }
        this.getIncomeAuth()
      },
      //获取节能列表
      projectEnergySaveStatistics() {
        let tmpData = {};
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.projectEnergySaveStatistics(params).then(res => {
          if (res.data.code == 200) {
            tmpData = res.data.data;
            this.statisticsData.map(item => {
              if (tmpData.hasOwnProperty(item.k)) {
                item.number = tmpData[item.k];
                return item;
              }
            });
          }
        });
      },
      //获取中间页面的统计数据
      searchSolarAndEnergyStorageIncomeAndSaveEmissions() {
        let tmpData = {};
        let params = {
          projectId: this.$route.query.projectId
        };
        PROJECTAPI.searchSolarAndEnergyStorageIncomeAndSaveEmissions(params).then(res => {
          if (res.data.code == 200) {
            tmpData = res.data.data;
            this.statisticsData.map(item => {
              if (tmpData.hasOwnProperty(item.k)) {
                item.number = tmpData[item.k];
                return item;
              }
            });
          }
        });
      },
      //获取收益评估权限
      getIncomeAuth(){
        let params = {
          resourceId: 186,
          projectId: this.$route.query.projectId
        };
        USERAPI.searchUserResources(params).then(res => {
          localStorage.setItem('incomeAuth', JSON.stringify(res.data.data));
        });
      },
      //切换面板
      switchPanel() {
        this.panelTitle = this.panelTitle == '隐藏面板' ? '显示面板' : '隐藏面板';
        this.panelShow = this.panelShow == false ? true : false;
      },
      glPanel(event) {
        if (event) {
          this.panelTitle = '显示面板';
          this.panelShow = true;
        } else {
          this.panelTitle = '隐藏面板';
          this.panelShow = false;
        }
      },
      //切换菜单
      switchMenu(item) {
        this.activeProject = item;
        let path = this.$route.path;
        let query = {
          ...this.$route.query
        };
        query.appid = this.activeProject;
        let isClearInterval = 0;
        if (item == 'projectHome') {
          query = {
            projectId: this.$route.query.projectId
          };
          isClearInterval = 0;
        } else {
          isClearInterval = 1;
        }
        sessionStorage.setItem('isClearInterval', isClearInterval);
        this.$router.push({
          path: path,
          query: query
        });
      },
      searchFixSimulationPanelData() {
        let params = {
          projectId: this.projectId
        };
        PROJECTAPI.searchFixSimulationPanelData(params).then(res => {
          if (res.data.code == 200 && !res.data.errors) {
            let panelIds = res.data.data;
            if (panelIds.length > 3) {
              this.isRightBlock = true;
            } else {
              this.isRightBlock = false;
            }
            this.panelIds = panelIds;
            panelIds.forEach((item) => {
              for(let i=0;i<centerImages.length;i++){
                if(item.panelId==centerImages[i].panelId){
                  this.centerImgId = centerImages[i].panelId;
                  this.centerImg = centerImages[i].src;
                  break
                }
              }
            })
            for (let i in panelIds) {
              if (panelIds[i].panelId == 90016 || panelIds[i].panelId == 90017) {
                if (panelIds[i].data[0].formObjects.length == 5) {
                  this.statisticsData = [{
                      k: 'solarIncome',
                      src: '/static/images/svolt/nanwang/guang-icon.png',
                      number: panelIds[i].data[0].formObjects[0].value != "-" && panelIds[i].data[0]
                        .formObjects[0]
                        .value != "" ? Number(JSON.parse(panelIds[i].data[0].formObjects[0].value).value)
                        .toFixed(2) : "0.00",
                      desc: '光伏总收益（万元）'
                    },
                    {
                      k: 'energyIncome',
                      src: '/static/images/svolt/nanwang/chu-icon.png',
                      number: panelIds[i].data[0].formObjects[0].value != "-" && panelIds[i].data[0]
                        .formObjects[0]
                        .value != "" ? Number(JSON.parse(panelIds[i].data[0].formObjects[1].value).value)
                        .toFixed(2) : "0.00",
                      desc: '储能收益（万元）'
                    },
                    {
                      k: 'saveCoal',
                      src: '/static/images/svolt/nanwang/mei-icon.png',
                      number: panelIds[i].data[0].formObjects[0].value != "-" && panelIds[i].data[0]
                        .formObjects[0]
                        .value != "" ? Number(JSON.parse(panelIds[i].data[0].formObjects[2].value).value)
                        .toFixed(2) : "0.00",
                      desc: '节约标准煤（吨）'
                    },
                    {
                      k: 'co2less',
                      src: '/static/images/svolt/nanwang/yang-icon.png',
                      number: panelIds[i].data[0].formObjects[0].value != "-" && panelIds[i].data[0]
                        .formObjects[0]
                        .value != "" ? Number(JSON.parse(panelIds[i].data[0].formObjects[3].value).value)
                        .toFixed(2) : "0.00",
                      desc: '二氧化碳减排量（吨）'
                    },
                    {
                      k: 'treeVolume',
                      src: '/static/images/svolt/nanwang/shu-icon.png',
                      number: panelIds[i].data[0].formObjects[0].value != "-" && panelIds[i].data[0]
                        .formObjects[0]
                        .value != "" ? Number(JSON.parse(panelIds[i].data[0].formObjects[4].value).value)
                        .toFixed(2) : "0.00",
                      desc: '相当于植树（颗）'
                    }
                  ];
                }
                if (panelIds[i].data[0].formObjects.length == 3) {
                  this.statisticsData = [{
                      k: 'saveCoal',
                      src: '/static/images/svolt/nanwang/mei-icon.png',
                      number: panelIds[i].data[0].formObjects[0].value != "-" && panelIds[i].data[0]
                        .formObjects[0]
                        .value != "" ? Number(JSON.parse(panelIds[i].data[0].formObjects[0].value).value)
                        .toFixed(2) : "0.00",
                      desc: '节约标准煤（吨）'
                    },
                    {
                      k: 'co2less',
                      src: '/static/images/svolt/nanwang/yang-icon.png',
                      number: panelIds[i].data[0].formObjects[0].value != "-" && panelIds[i].data[0]
                        .formObjects[0]
                        .value != "" ? Number(JSON.parse(panelIds[i].data[0].formObjects[1].value).value)
                        .toFixed(2) : "0.00",
                      desc: '二氧化碳减排量（吨）'
                    },
                    {
                      k: 'treeVolume',
                      src: '/static/images/svolt/nanwang/shu-icon.png',
                      number: panelIds[i].data[0].formObjects[0].value != "-" && panelIds[i].data[0]
                        .formObjects[0]
                        .value != "" ? Number(JSON.parse(panelIds[i].data[0].formObjects[2].value).value)
                        .toFixed(2) : "0.00",
                      desc: '相当于植树（颗）'
                    }
                  ];
                }
              }
            }

          }
          this.$nextTick(() => {
            this.init();
          })
        })
      },
      setCollapse(event) {
        this.isShowMenu = event;
        let leftBox = document.getElementsByClassName("list-block-left");
        let centerBox = document.getElementsByClassName("centerBox");
        let sPanel = document.getElementsByClassName("s-hide-panel");
        if (this.$refs.projectHome) {
          if (event) {
            this.$refs.projectHome.style.width = "calc(100% - 240px)";
            this.$refs.projectHome.style.marginLeft = "240px";
            if(leftBox[0]){
              leftBox[0].style.marginLeft = "240px";
            }
            //区分首页效果
            if (this.$route.query.appid) {
              if (centerBox[0])
                centerBox[0].style.width = "calc(100% - 240px)";
            } else {
              if (centerBox[0]){
                centerBox[0].style.width = "100%";
              }
            }
            if(sPanel[0]){
              sPanel[0].style.left = "56%";
            }
          } else {
            this.$refs.projectHome.style.width = "100%";
            this.$refs.projectHome.style.marginLeft = "0px";
            if(leftBox[0]){
              leftBox[0].style.marginLeft = "0px";
            }
            if (centerBox[0]){
              centerBox[0].style.width = "100%";
            }
            if(sPanel[0]){
              sPanel[0].style.left = "50%";
            }
          }
        }
      },
      //重置模块
      resetBlock() {
        let leftBox = document.getElementsByClassName("list-block-left");
        let centerBox = document.getElementsByClassName("centerBox");
        if (this.$refs.projectHome) {
          if (this.isShowMenu) {
            //区分首页效果
            if (this.$route.query.appid) {
              this.$refs.projectHome.style.width = "calc(100% - 240px)";
              this.$refs.projectHome.style.marginLeft = "240px";
              leftBox[0].style.marginLeft = "240px";
              centerBox[0].style.width = "calc(100% - 240px)";
            } else {
              this.$refs.projectHome.style.width = "100%";
              this.$refs.projectHome.style.marginLeft = "240px";
              leftBox[0].style.marginLeft = "240px";
              centerBox[0].style.width = "100%";
            }
          } else {
            this.$refs.projectHome.style.width = "100%";
            this.$refs.projectHome.style.marginLeft = "0px";
            leftBox[0].style.marginLeft = "0px";
            centerBox[0].style.width = "100%";
          }
        }
      },
      toggleFullscreen() {
        if (document.fullscreenElement) {
        } else {
        }
      }
    },
    watch: {
      $route: {
        handler: function(to, from) {
          this.loading = true
        },
        deep: true
      }
    },
    beforeMount(){
    },
    created() {
      this.loading = true
      this.projectId = this.$route.query.projectId;
      sessionStorage.setItem('isClearInterval', 0);
      this.searchFixSimulationPanelData();
      // if (this.$route.query.appid) {
      //   clearInterval(this.interval);
      // } else {
      //   this.interval = setInterval(() => {
      //     this.init();
      //   }, 60000);
      // }
      let self = this
      setTimeout(function() {
        self.loading = false;
      }, 3000)
    },
    mounted() {
      let projectList = JSON.parse(localStorage.getItem('ProjectList'));
      for (let i in projectList) {
        if (this.$route.query.projectId == projectList[i].projectId) {
          this.sceneType = projectList[i].sceneType;
        }
      }

      //增加项目主页中间模块定时刷新，刷新频率 60s
      this.interval = setInterval(() => {
        var isClearInterval = sessionStorage.getItem('isClearInterval');
        if (isClearInterval == 0) {
          this.searchRealTimePower();
        }
      }, 1000*60*1);

    },
    beforeDestroy() {
      clearInterval(this.interval);
      // this.loading = false
    }
  }
</script>

<style lang="scss" scoped>
  .loading-x {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99999;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 400px;
      height: 300px;
    }

    span {
      position: absolute;
      margin-top: 38px;
      font-size: 15px;
      font-weight: 600;
      font-family: auto;
    }
  }

  .s-project {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    background-color: #d8e8fe;

    .s-header {}

    .navMenu {
      width: 240px;
      /*no*/
      height: 100%;
      background: linear-gradient(135deg, #679FE7 0%, #DCE9FE 100%);
      position: fixed;
      margin-top: -12px;
      z-index: 99999;
    }

    .s-statistics {
      margin-top: 10px;
      z-index: 999;
    }

    .t-row {
      margin-top: 20px;
    }

    .list-block-left {
      top: 75px;
      left: 20px;
      z-index: 999;
    }

    .list-block-right {
      top: 75px;
      right: 20px;
      z-index: 999;
    }

    .s-hide-panel {
      position: absolute;
      // background: #1a6bd1;
      background: linear-gradient(180deg, #ACC7EC 0%, #3F73CB 100%);
      border: none;
      border-radius: 4px;
      color: #fff;
      bottom: 25px;
      left: 50%;
      transform: translateX(-50%);
      width: 86px;
      height: 44px;
      line-height: 20px;
      z-index: 99;

      &:hover {
        cursor: pointer;
      }

      span {
        display: block;
        position: absolute;
        width: 86px;
        height: 44px;
        line-height: 44px;
        top: 0px;
        left: 0px;
        text-align: center;
      }
    }

    .b-hide-panel {
      position: absolute;
      background: linear-gradient(180deg, #ACC7EC 0%, #3F73CB 100%);
      border: none;
      border-radius: 4px;
      color: #fff;
      bottom: 25px;
      right: 10% !important;
      left: auto !important;
      transform: translateX(-50%);
      width: 86px;
      height: 44px;
      line-height: 20px;
      z-index: 99;

      &:hover {
        cursor: pointer;
      }

      span {
        display: block;
        position: absolute;
        width: 86px;
        height: 44px;
        line-height: 44px;
        top: 0px;
        left: 0px;
        text-align: center;
      }
    }
  }
</style>
<style lang="scss">
  .left-show {
    -webkit-animation-name: panelLeftA;
    animation-name: panelLeftA;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  .left-hide {
    -webkit-animation-name: panelRightA;
    animation-name: panelRightA;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  .right-show {
    -webkit-animation-name: panelLeftB;
    animation-name: panelLeftB;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  .right-hide {
    -webkit-animation-name: panelRightB;
    animation-name: panelRightB;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  @keyframes panelLeftA {
    from {
      left: 20px;
    }

    to {
      left: -418px;
      -webkit-transform: translateX(-120px);
      transform: translateX(-120px);
    }
  }

  @keyframes panelRightA {
    from {
      left: -418px;
    }

    to {
      left: 140px;
      -webkit-transform: translateX(-120px);
      transform: translateX(-120px);
    }
  }

  @keyframes panelLeftB {
    from {
      right: -95px;
    }

    to {
      right: -533px;
      -webkit-transform: translateX(-120px);
      transform: translateX(-120px);
    }
  }

  @keyframes panelRightB {
    from {
      right: -513px;
    }

    to {
      right: -95px;
      -webkit-transform: translateX(-120px);
      transform: translateX(-120px);
    }
  }

  .ext-menu-list {
    margin: 0px 24px;
    margin-top: 24px;
    font-size: 12px;

    .ext-btn {
      width: 100%;
      font-size: 12px;
      text-align: left;
      background: #409eff;
      border: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/index.vue